import { defineMessages } from "react-intl";

export const transactionGiftCardMessages = defineMessages({
  giftCard: {
    defaultMessage: "Gift card (**** {code})",
    id: "e5Mlfh",
    description: "Transaction title",
  },
  usedInOrder: {
    defaultMessage: "Used in order",
    id: "x2mg39",
    description: "Transaction event description",
  },
});
